(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-set"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-banner"] && !Shopify.designMode) return;
  try {
    
// Load reCAPTCHA v3
(function() {
  const form = document.getElementById('ContactForm');
  if (!form) return;
  
  const siteKey = form.getAttribute('data-recaptcha-key');
  if (siteKey) {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
    script.async = true;
    document.head.appendChild(script);
  }
})();

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ContactForm');
  if (!form) return;
  
  const submitBtn = document.getElementById('submit-btn');
  const formResponse = document.getElementById('form-response');
  const siteKey = form.getAttribute('data-recaptcha-key');
  const webhookUrl = form.getAttribute('data-webhook-url');
  const originalBtnText = submitBtn ? submitBtn.textContent : 'Send';
  let isSubmitting = false;

  if (form && siteKey && webhookUrl) {
    form.addEventListener('submit', async function(e) {
      // Prevent multiple submissions
      if (isSubmitting) {
        e.preventDefault();
        return;
      }
      
      e.preventDefault();
      isSubmitting = true;
      
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
      }

      try {
        // Get reCAPTCHA token
        const token = await grecaptcha.execute(siteKey, { action: 'contact' });
        
        // Collect form data
        const formData = {
          name: document.getElementById('ContactForm-name').value,
          email: document.getElementById('ContactForm-email').value,
          phone: document.getElementById('ContactForm-phone').value,
          message: document.getElementById('ContactForm-body').value,
          productName: document.getElementById('product_name').value,
          productLink: document.getElementById('product_link').value,
          recaptchaToken: token,
          timestamp: new Date().toISOString()
        };

        // Send to Google Sheets webhook (for monitoring with reCAPTCHA scores)
        await fetch(webhookUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        });

        // Wait a moment for webhook to process
        await new Promise(resolve => setTimeout(resolve, 500));

        // Now allow the form to submit to Shopify (for email notifications)
        // Remove the event listener to prevent infinite loop
        form.removeEventListener('submit', arguments.callee);
        
        // Submit the form natively to Shopify
        // If a thank-you page is configured, redirect after a short delay
        const thankYouPage = '{{ section.settings.thank_you_page }}';
        if (thankYouPage) {
          // Send form data to Shopify via fetch, then redirect
          const nativeFormData = new FormData(form);
          await fetch(form.action, {
            method: 'POST',
            body: nativeFormData
          });
          window.location.href = thankYouPage;
          return;
        }
        form.submit();
        
      } catch (error) {
        isSubmitting = false;
        if (formResponse) {
          formResponse.style.display = 'block';
          formResponse.style.backgroundColor = '#f8d7da';
          formResponse.style.color = '#721c24';
          formResponse.textContent = 'Sorry, there was an error sending your message. Please try again.';
        }
        
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        
        // Hide message after 5 seconds
        setTimeout(function() {
          if (formResponse) {
            formResponse.style.display = 'none';
          }
        }, 5000);
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
